export default __webpack_public_path__ + "static/media/green_bottom_arrow.e42c1e52.svg";